<template>
    <div>
        <div class="contact-info">
            <!--<h2 class="contact-info__title">Не нашли документацию? Напишите нам</h2>-->
            <h2 class="contact-info__title">Напишите нам</h2>
            <p class="contact-info__description">Вышлем информацию вам на почту</p>

            <form id="form" class="form contact-info__form">
                
                <input type="text" name="Имя" placeholder="Ваше Имя*" class="form__input" required><br>
                <input type="email" name="E-mail" placeholder="Ваш email*" class="form__input" required><br>
                <input type="organization" name="Организация" placeholder="Укажите организацию*" class="form__input" required><br>
                <textarea name="Вопрос" cols="30" rows="5" placeholder="Напишите свой вопрос*" class="form__input form__textarea" required></textarea>

                <!-- Hidden Required Fields -->
                <input type="hidden" name="project_name" value="ПАО Электромеханика">
                <input type="hidden" name="admin_email" value="sergius.glad@yandex.ru">
                <input type="hidden" name="form_subject" value="Запрос документации">
                <!-- END Hidden Required Fields -->

                <div class="contact-info__form-button">
                    <button>Отправить</button>
                </div>

                <div class="success" >
                    <div class="success__body">
                        <div class="success__title">Письмо успешно отправлено!</div>
                    </div>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            
        }
    }
}
</script>

<style lang="sass">
.contact-info
    @media screen and (max-width: 969px)
        margin-bottom: 25px
    &__title
        margin: 0
    &__description
        font-size: 14px
        margin-top: 7px
    &__form
        input
            font-size: 12px
            color: #9E9E9E
            width: 100%
            padding: 10px 10px
            margin-bottom: 15px
            border: 1px solid #01278621
            border-radius: 4px
        textarea
            font-family: inherit
            font-size: 12px
            color: #9E9E9E
            width: 100%
            padding: 10px 10px
            border: 1px solid #01278621
            border-radius: 4px
        &-button
            button
                border: 1px solid #8193ba
                text-align: center
                font-family: inherit
                font-size: 11px
                padding: 10px 40px
                color: #202c45
                cursor: pointer
                border-radius: 5px
                box-shadow: 0 8px 15px rgba(129, 147, 186, 0.26)
                transition: 0.5s
                margin-top: 12px
                background-color: #8193ba
                color: #fff
                &:disabled
                    cursor: unset
                    box-shadow: none
                    background-color: lighten(#8193ba, 20%)
                    border: none
                    color: #8193ba
                    &:hover
                        box-shadow: none
                        background-color: lighten(#8193ba, 20%)
                        border: none
                        color: #8193ba
                &:hover
                    background-color: darken(#8193ba, 20%)
                    color: #ffffff
.success
    display: none
    &_active
        display: block
        margin-top: 20px
    &__body
        background-color: green
        padding: 10px
    &__title
        color: #fff
        font-size: 14px

.notification
    margin-top: 20px
    background-color: green
    padding: 10px
    color: #fff
    font-size: 14px
</style>